module.exports = __webpack_public_path__ + "static/media/Ninad Barve.d5f44210.jpg";